export default __webpack_public_path__ + "static/media/shafiGlucoChem.1c2b2277.jpeg";